import type { Nullable } from "@core/domain/types/nullable.type";
import { SensorDtoSchema } from "@station/data/dto/sensor.dto";
import * as z from "zod";

const VariableAlertDtoSchema = z.object({
    id: z.number(),
    hours_elapsed_to_trigger: z.number(),
    low_trigger_value: z.number().nullable(),
    high_trigger_value: z.number().nullable(),
    variable: SensorDtoSchema,
    active_in_stations_label: z.string().trim().optional(),
    active_in_stations_ids: z.array(z.number()).optional(),
});

export const SensorAlertDtoSchema = z
    .object({
        id: z.number(),
        name: z.string().trim(),
        unique_trigger: z.boolean(),
        notify_all: z.boolean(),
        is_enabled: z.boolean(),
        stations: z.record(z.string(), z.string().trim()).nullable(),
        last_notification_at: z.string().trim().nullable(),
        station_ids: z.array(z.number()),
        variable_alerts: z.array(VariableAlertDtoSchema),
    })
    .readonly();

export type SensorAlertDto = z.output<typeof SensorAlertDtoSchema>;

export const SensorAlertsDtoSchema = z.array(SensorAlertDtoSchema).readonly();

export type SensorAlertsDto = z.output<typeof SensorAlertsDtoSchema>;

export interface SensorAlertUpdateBody {
    combined_variable_alert: {
        name: string;
        unique_trigger: boolean;
        notify_all: boolean;
        is_enabled: boolean;
        station_ids: number[];
        variable_alerts_attributes: {
            id: number;
            variable_id: number;
            hours_elapsed_to_trigger: number;
            low_trigger_value: Nullable<number>;
            high_trigger_value: Nullable<number>;
        }[];
    };
}
